import React from 'react';
import {
  ClockInOutline,
  ClockOutOutline,
  EndLunchOutline,
  StartLunchOutline,
} from '@4r/module-common-ant-components';

type EventIconProps = { iconType?: string };

const EventIcon: React.FC<EventIconProps> = ({ iconType }) => {
  switch (iconType) {
    case '4ed06c66-5dcd-4542-adad-68d1ddc23860':
      return <ClockInOutline size="small" />;
    case '2b422143-81c0-45f0-a02a-f324689c835e':
      return <ClockOutOutline size="small" />;
    case '6b3f5c68-5235-4889-8b52-8738e99c9a9e':
      return <StartLunchOutline size="small" />;
    case '5b7cb1ab-790c-427f-bbb3-8f222c4e3abc':
      return <EndLunchOutline size="small" />;
    default:
      return null;
  }
};

export default EventIcon;
